import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DashboardService } from '../../core/api-services/dashboard.service';

/**
 * Admin Dashboard Component
 * Main landing page for admin portal showing key metrics and quick actions.
 * Fetches live stats from GET /admin/dashboard/stats on init.
 */
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  statsLoading = true;
  totalUsers = '--';
  activeDrones = '--';
  openTickets = '--';
  activeOrganizations = '--';

  constructor(private dashboardService: DashboardService) {}

  async ngOnInit(): Promise<void> {
    try {
      const stats = await firstValueFrom(this.dashboardService.getStats());
      this.totalUsers = String(stats.totalUsers);
      this.activeDrones = String(stats.activeDrones);
      this.openTickets = String(stats.openTickets);
      this.activeOrganizations = String(stats.activeOrganizations);
    } catch (error) {
      console.error('Failed to load dashboard stats:', error);
      // Graceful degradation: leave values as '--'
    } finally {
      this.statsLoading = false;
    }
  }
}
